import React, { lazy, Suspense } from 'react';

const LazyFaceIdUpdate = lazy(() => import('./FaceIdUpdate'));

const FaceIdUpdate = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyFaceIdUpdate {...props} />
  </Suspense>
);

export default FaceIdUpdate;
